// extracted by mini-css-extract-plugin
export default {"header":"ratingTrend_header__A5oun","title":"ratingTrend_title__DoCO-","subtitle":"ratingTrend_subtitle__8606e","chart":"ratingTrend_chart__dYKwF"};